// extracted by mini-css-extract-plugin
export default {"form":"g8qnsURcSz5GcFDCvrEt"};